import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'job-details/root-causes';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_LOG_LINES = createApiNamespacedConstants('GET_LOG_LINES');

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
